export const dwLanguagePre = {
  menu: 'menu.',
  program: 'prog.',
  page: 'page.'
};
